export const Footer = () => (
  <footer className="px-4 md:px-12 py-12 border-t border-gray-800 mt-8 bg-black">
    <div className="max-w-6xl mx-auto">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
        <div>
          <h5 className="text-white font-medium mb-4">Navigation</h5>
          <ul className="space-y-2 text-sm text-gray-400">
            <li><a href="/" className="hover:text-red-500">Home</a></li>
            <li><a href="/live-tv" className="hover:text-red-500">Live TV</a></li>
            <li><a href="/guide" className="hover:text-red-500">TV Guide</a></li>
            <li><a href="/movies" className="hover:text-red-500">Movies</a></li>
          </ul>
        </div>
        <div>
          <h5 className="text-white font-medium mb-4">Support</h5>
          <ul className="space-y-2 text-sm text-gray-400">
            <li><a href="#" className="hover:text-red-500">Help Center</a></li>
            <li><a href="#" className="hover:text-red-500">Contact Us</a></li>
            <li><a href="#" className="hover:text-red-500">FAQ</a></li>
          </ul>
        </div>
        <div>
          <h5 className="text-white font-medium mb-4">Legal</h5>
          <ul className="space-y-2 text-sm text-gray-400">
            <li><a href="#" className="hover:text-red-500">Privacy Policy</a></li>
            <li><a href="#" className="hover:text-red-500">Terms of Service</a></li>
          </ul>
        </div>
        <div>
          <h5 className="text-white font-medium mb-4">Connect</h5>
          <ul className="space-y-2 text-sm text-gray-400">
            <li><a href="#" className="hover:text-red-500">Twitter</a></li>
            <li><a href="#" className="hover:text-red-500">Instagram</a></li>
            <li><a href="#" className="hover:text-red-500">Facebook</a></li>
          </ul>
        </div>
      </div>
      <div className="text-center">
        <h2 className="text-2xl font-bold mb-2">
          <span className="text-white">CBX</span>
          <span className="text-red-600">TV</span>
        </h2>
        <p className="text-gray-500 text-sm">&copy; 2025 CBXTV. All rights reserved.</p>
      </div>
    </div>
  </footer>
);
